//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'questionnaire',
    data() {
        var vm = this;
        return {
            loading: false,
            searchInput: {},
            columns: [
                {
                    type: 'index',
                    width: 66,
                    title: '序号',
                    align: 'center'
                },
                {
                    title: '标题',
                    key: 'name', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        var t = row.name;
                        if (!row.name) {
                            t = '问卷标题';
                        }
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showDetail(row);
                                }
                            }
                        }, t));
                        return h('div', actions);
                    }
                },
                {
                    title: '有效期', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.startDateTimeStr && row.endDateTimeStr) {
                            return h('span', row.startDateTimeStr + '—' + row.endDateTimeStr);
                        } else {
                            return h('span', '');
                        }
                    }
                },
                {
                    title: '赠送积分', align: 'center',
                    key: 'point'
                },
                {
                    title: '状态', align: 'center',
                    key: 'statusStr'
                },
                {
                    title: '操作', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        // var del = h('Button', {
                        //     props: {
                        //         type: 'error',
                        //         size: 'small'
                        //     },
                        //     style: {
                        //         marginRight: '5px'
                        //     },
                        //     on: {
                        //         click: () => {
                        //             vm.delQuestionnaire(params.row);
                        //         }
                        //     }
                        // }, '查看');

                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    // vm.questionnaireEdit(params.row);
                                    vm.$router.push({
                                        name: 'questionnaire-data',
                                        params: {
                                            id: params.row.id
                                        }
                                    });
                                }
                            }
                        }, '查看');

                        // if (row.status == 0) {
                        actions.push(edit);
                        // actions.push(del);
                        // }


                        return h('div', actions);
                    }
                }
            ],
            showQuestionModel: false,
            saving: false,
            rules: {
                name: { required: true, message: '请输入问卷标题', trigger: 'blur' },
                startDateTime: [{ required: true, type: 'date', message: '请选择日期', trigger: 'change' }],
                endDateTime: [{ required: true, type: 'date', message: '请选择日期', trigger: 'change' }]
            },
            questionnaire: {
                id: 0,
                name: '问卷标题'
                // startDateTime: ''
            },
            options3: {
                disabledDate(date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                }
            },
            cityList: []
        };
    },
    methods: {
        pageChange(page) {
            this.$store.commit('questionnaire/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('questionnaire/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'questionnaire/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        editQuestionnaire(q) {
            // this.questionnaire = q;
            // this.showQuestionModel = true;
            // this.onSave();

            this.questionnaireEdit(q);
        },
        cancel() {
            this.showQuestionModel = false;
        },
        onSave() {

            // this.$refs.questionnaireForm.validate((valid) => {
            //     if (valid) {
            //         this.$Message.success('Success!');
            //     } else {
            //         this.$Message.error('Fail!');
            //     }
            // });
            // this.$refs.questionnaireForm.validate(async (val) => {
            //     if (val) {
            this.saving = true;
            this.$store.dispatch({
                type: 'questionnaire/saveQuestionnaire',
                data: this.questionnaire
            })
                .then(() => {
                    this.loading = false;
                    this.showQuestionModel = false;
                    var qid = this.$store.state.questionnaire.qId;
                    var row = {
                        id: qid
                    };

                    // this.getPage();
                }).finally(() => {
                this.saving = false;
            });
            //     }
            // });
        },
        questionnaireEdit(q) {
            this.$router.push({
                name: 'questionnaireEdit',
                params: {
                    id: q.id
                }
            });
        },
        delQuestionnaire(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.loading = true;
                    vm.$store.dispatch({
                        type: 'questionnaire/delQuestionnaire',
                        id: row.id
                    }).then(() => {
                        vm.getPage();
                    }).finally(() => {
                        vm.loading = false;
                    });

                }
            });
        },
        showDetail(row) {
            this.$router.push({
                name: 'questionnaireDetail',
                params: {
                    id: row.id
                }
            });
        },
        getCities() {
            this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
                this.cityList = this.$store.state.city.cityList;
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    computed: {
        currentPage() {
            return this.$store.state.questionnaire.currentPage;
        },
        totalCount() {
            return this.$store.state.questionnaire.totalCount;
        },
        pageSize() {
            return this.$store.state.questionnaire.pageSize;
        },
        list() {
            return this.$store.state.questionnaire.list;
        }

    },
    created() {
        this.getPage();
        this.getCities();
    }
};
